import { collection, onSnapshot, orderBy, query } from 'firebase/firestore';
import React, { createContext, useState,useEffect,useRef,useCallback } from 'react'
import { GoogleMap,Marker, useJsApiLoader,InfoWindow, InfoBox, InfoWindowF } from "@react-google-maps/api";
import "./Plan.css"
import { darkStyle } from './MapDesign';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import Typography from '@mui/material/Typography';
import { CardActionArea } from '@mui/material';
import { Button } from '@material-ui/core';
import PlanDirect from './PlanDirect';
import { center, defaultSpots, SelectSpot, spot } from '../types';



const options = {
    disableDefaultUI: true,
    zoomControl: true,
    gestureHandling: 'greedy',
    clickableIcons:false,
    styles:darkStyle
  };


function Plan() {
  const [focusSpot,setFocusSpot] = useState<spot[]>(defaultSpots)
  const [mapSpot,setMapSpot] = useState<spot[]>(defaultSpots)
  const [finalSpot,setFinalSpot] = useState<spot[]>([])
  const [check,setCheck] = useState<boolean>(false)
  const [focusCenter,setFocusCenter] = useState<center>({lat:35.68146,lng:139.76707})
  const [naviStart,setNaviStart] = useState<boolean>(false)
  
  const handleSpotChange = (e: any) =>{
    const selectSpots = [...defaultSpots].filter((item)=>{
      return (
        item.place === e.target.value
        )
    })
    setNaviStart(false)
    setFocusSpot(selectSpots);
    setFocusCenter({lat:selectSpots[0].location.lat,lng:selectSpots[0].location.lng})
  }

  
  const StartMapNavi = () =>{
    setNaviStart(true)
    setMapSpot(focusSpot)
  }
  
  const {isLoaded}= useJsApiLoader({
    id:'google-map-script',
    googleMapsApiKey:"AIzaSyAGQ3UnxYDs-DziKsRr1fLqatZCM0o9Fm0",
  })
  const mapRef = useRef()
  const onLoad = useCallback((map:any)=>(mapRef.current),[])

  const containerStyle = {
    height: "60vh",
    width: "100%",
  };

  const newFocusSpot = [...focusSpot].slice(1,-1)


  return (
    <>
     <div className="Plan-Page">
         <div className='Plan-Search'>
           <h2>行きたい場所、予算を決めてルートを決めてみよう！</h2>
           <div className='Plan-CheckBoxes'>
             <select onChange={handleSpotChange} className='Plan-Select'>
              <option hidden>スポットを選ぼう</option>
                {SelectSpot.map((item)=>{
                    return(
                      <option value={item.name}>{item.name}</option>
                    )
                })}
             </select>
             <Button onClick={StartMapNavi}>決定</Button>
             <div className='Plan-Check'>
               
             </div>
           </div>
         </div>

         <div className='Plan-Pictures'>
          {focusSpot.map((item:spot)=>(
           <div className='Plan-Picture' key={item.name}>
            <Card sx={{ maxWidth: 345 }}>
             <CardActionArea>
              <CardMedia
                component="img"
                height="180"
                image={item.image}
                alt={item.place}
             />
              <CardContent>
               <Typography gutterBottom variant="h5" component="div">
                 {item.name}
               </Typography>
              <Typography variant="body2" color="text.secondary">
               <input type="checkbox" onChange={()=>{!item.check}} value={item.name}/>
              </Typography>
             </CardContent>
             </CardActionArea>
            </Card>
           </div>
            ))}
         </div>

        <div className='Plan-Navi'>
          {isLoaded&&
           <GoogleMap
           mapContainerStyle={containerStyle}
           center={focusCenter}
           zoom={11}
           options={options}
           onLoad={onLoad}
           >
           
           {mapSpot.map((item:spot)=>(
             <Marker
             position={{lat:item.location.lat,lng:item.location.lng}}
             />
           ))}
            { naviStart &&
            <PlanDirect
            origin={{lat:focusSpot[0].location.lat,lng:focusSpot[0].location.lng}}
            destination={{lat:focusSpot[focusSpot.length -1].location.lat,lng:focusSpot[focusSpot.length-1].location.lng}}
            transitPoints = {newFocusSpot.map(({ name,place,spece,money,check,image, ...rest }) => rest)}
            />
            }
           </GoogleMap>}
          
        </div>

    
        
     </div>
    </>
  )
}

export default Plan